import { TillPaymentStatus } from "../../models/till/ITillSale";

/** The reader still has the card, or hasn't been reached yet: keep polling. */
export function shouldPollSale(status: TillPaymentStatus | undefined): boolean {
  return status === "Pending" || status === "Processing";
}

/** Declined or refused by the reader: the operator decides what happens next. */
export function needsOperator(status: TillPaymentStatus | undefined): boolean {
  return status === "RequiresRetry";
}

export function isSaleComplete(status: TillPaymentStatus | undefined): boolean {
  return status === "Succeeded" || status === "PartiallyRefunded" || status === "Refunded";
}

export function isSaleOver(status: TillPaymentStatus | undefined): boolean {
  return status === "Failed" || status === "Cancelled" || isSaleComplete(status);
}
